import React from 'react';
import { Card, CardProps, Col, Row } from 'react-bootstrap';

import cx from 'classnames';

import s from './HorizontalRightImageContent.module.scss';

interface HorizontalRightImageProps extends CardProps {
  imageUrl: string;
  imageAlt?: string;
  className?: string;
  style?: any;
}
const HorizontalRightImageContent: React.FC<HorizontalRightImageProps> = ({
  imageUrl,
  imageAlt,
  className,
  children,
  ...props
}) => {
  return (
    <Card
      className={cx(s['horizontal-right-image'], 'overflow-hidden', className)}
      {...props}
    >
      <Card.Body className="p-0">
        <Row className="m-0">
          <Col sm={12} lg={6} className={s['horizontal-right-content-wrapper']}>
            {children}
          </Col>
          {imageUrl && (
            <Col
              sm={12}
              lg={6}
              className={cx(s['horizontal-right-image-wrapper'])}
            >
              <img
                loading="lazy"
                className="w-100"
                src={imageUrl}
                alt={imageAlt}
              />
            </Col>
          )}
        </Row>
      </Card.Body>
    </Card>
  );
};

export default HorizontalRightImageContent;
